import styled, { css } from 'styled-components';

export const Container = styled.section`
  ${({ theme }) => css`
    background: ${theme.palette.neutral[50]};
    display: flex;
    flex-direction: column;
    border-radius: 1rem 1rem 0 0;

    .content {
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(2)};
      padding: ${theme.layout.spacing(3)};

      p {
        font-size: ${theme.typography.sizes.body2};
        color: ${theme.palette.text.main};
        white-space: pre-line;
      }
    }

    .actions {
      display: flex;
      gap: ${theme.layout.spacing(2)};
      padding: ${theme.layout.spacing(0, 3, 3)};

      button {
        flex: 1;
      }
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      max-width: ${theme.layout.spacing(48)};
      border-radius: 1rem;
    }
  `}
`;
